import { render } from "./Rebates.vue?vue&type=template&id=6e2ca151"
import script from "./Rebates.vue?vue&type=script&lang=js"
export * from "./Rebates.vue?vue&type=script&lang=js"

import "./Rebates.vue?vue&type=style&index=0&id=6e2ca151&lang=css"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__